import { ocrAPI } from '../../../api/ocr.js';

/**
 * Extract text from a cropped base64 image via the on-premise OCR backend.
 * GDPR compliant: document data stays on the server, never sent to third-party APIs.
 *
 * @param {string} croppedBase64 - Base64 PNG of the cropped selection (with data URI prefix)
 * @param {string} fieldHint - OCR hint from the scan step config
 * @returns {Promise<string>} Extracted text, or "???" on failure
 */
export async function ocrExtract(croppedBase64, fieldHint) {
  try {
    const result = await ocrAPI.extract(croppedBase64, fieldHint);
    const text = result?.data?.text?.trim();
    return text || "???";
  } catch (err) {
    console.error("OCR error:", err);
    return "???";
  }
}
